var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('Connectors.Monitoring.dialogs.enable.title'),
      "open": _vm.open,
      "color": _vm.color,
      "buttons": _vm.promptButtons
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      },
      "cancel": function ($event) {
        return _vm.$emit('close');
      },
      "use-old": function ($event) {
        return _vm.$emit('confirm', true);
      },
      "create-new": function ($event) {
        return _vm.$emit('confirm', false);
      }
    }
  }, [_vm.hasExistingConfig ? _c('p', [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.enable.messageReuse', {
    date: _vm.lastDeactivatedDate
  })) + "\n  ")]) : _c('p', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.enable.messageNew')))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };